(function () {
  /*
    carredoux : revelation premium des sections au defilement.
    Chaque section de #MainContent glisse alternativement depuis la gauche puis la droite,
    avec un fondu lent. Le header et le footer ne bougent jamais.

    Le delai de secours de theme.liquid (4 s) ne sert que si ce script ne se charge pas :
    des que le script tourne, la classe scroll-reveal-ready le neutralise, pour que les
    sections s'animent aussi quand on defile apres 4 secondes.
  */
  var P = 'html.js-scroll-reveal.scroll-reveal-ready #MainContent .shopify-section';
  var css =
    P + '{transition:opacity 1.1s cubic-bezier(0.22,1,0.36,1),transform 1.1s cubic-bezier(0.22,1,0.36,1)}' +
    'html.js-scroll-reveal.scroll-reveal-ready #MainContent{overflow-x:clip}' +
    P + ':not(.is-visible){opacity:0;will-change:opacity,transform;transform:translate3d(-72px,0,0)}' +
    P + '[data-reveal="right"]:not(.is-visible){transform:translate3d(72px,0,0)}' +
    '@media (max-width:749px){' +
    P + ':not(.is-visible){transform:translate3d(-36px,0,0)}' +
    P + '[data-reveal="right"]:not(.is-visible){transform:translate3d(36px,0,0)}}';

  var style = document.createElement('style');
  style.setAttribute('data-cd-reveal', '');
  style.textContent = css;
  document.head.appendChild(style);

  function init() {
    var root = document.documentElement;
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || prefersReducedMotion || root.classList.contains('shopify-design-mode')) {
      sections.forEach(function (section) {
        section.classList.add('is-visible');
      });
      return;
    }

    sections.forEach(function (section, index) {
      section.setAttribute('data-reveal', index % 2 === 1 ? 'left' : 'right');
    });

    sections[0].classList.add('is-visible');
    root.classList.add('scroll-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      if (section === sections[0]) return;
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
